module.exports = require('./lib/react.js')



//////////////////
// WEBPACK FOOTER
// ./~/glamor/react.js
// module id = 26
// module chunks = 35783957827783 77745262586250 231608221292675